import React, { useState } from "react";

export const QuizContext = React.createContext();

export const ContextProvider = props => {
  const [howtoearpoint, updatehowtoearpoint] = useState("");
  const [leaderboardname,updateleaderboardname] = useState("");
  

  return (
    <QuizContext.Provider
      value={{
        howtoearpoint,
        updatehowtoearpoint,
        leaderboardname,
        updateleaderboardname
      }}
    >
      {props.children}
    </QuizContext.Provider>
  );
};



// WEBPACK FOOTER //
// ./src/shells/contextProvider.js